import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryMultipleTuitionFee extends TitleBase {
	private tuitionFeeValue: string;

	protected canHandle(): boolean {
		this.tuitionFeeValue = this.getFilterValue(ParameterType.TUITION_FEE);

		return (
			this.indexableFilters.length === 1 &&
			this.multiValueFilters.length >= 1 &&
			this.indexableFilters.some((_) => _.type === ParameterType.TUITION_FEE) &&
			this.multiValueFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected getPageTitle(): string {
		return `${this.tuitionFeeValue} ${this.titlePortalType} in selected countries`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.tuitionFeeValue} ${this.titlePortalType}`, ' in selected countries');
	}
}
